import { Label, Panel, PanelProps } from "@mcleod/components"
import { TimelineCalculator } from "./TimelineCalculator";
import { StyleUtil } from "@mcleod/core";

export class TimelineDayHeader extends Panel {
    private static readonly DATE_FORMATTING_PROPS: Intl.DateTimeFormatOptions = {
        weekday: "long",
        month: "short",
        day: "numeric"
    };

    constructor(date: Date, calculator: TimelineCalculator, props?: Partial<PanelProps>) {
        const calculatedWidth = 72 / calculator.oneBlockHours;
        const width = Math.max(calculatedWidth * calculator.scaleMultiplier, 18); // default to 18 as minimum width
        super({
            id: "panelDateHeader-" + date.toDateString(),
            color: "subtle",
            borderRightWidth: 1,
            borderRightColor: "subtle",
            backgroundColor: "backgroundSubtle",
            padding: 0,
            rowBreak: false,
            rowBreakDefault: false,
            width: StyleUtil.numberAsRems(width),
            wrap: false,
            ...props
        });
        this.style.flex = `0 0 ${width}rem`;
        this.add(this.buildDateLabel(date));
        this.calculateHours(calculator.oneBlockHours)?.forEach(hour => {
            this.add(this.buildHourLabel(hour, calculator.singleBlockWidthString));
        });
    }

    private calculateHours(granularity: number): string[] {
        const result: string[] = [ "" ]; // Blank string is midnight
        for (let x=(0+granularity) ; x<24 ; x=x+granularity) {
            result.push(String(x));
        }
        return result;
    }

    private buildDateString(date: Date): string {
        return date.toLocaleDateString("en-US", TimelineDayHeader.DATE_FORMATTING_PROPS);
    }

    private buildDateLabel(date: Date): Label {
        const dateString = this.buildDateString(date);
        return new Label({
            text: dateString,
            id: "labelDateTitle-" + dateString,
            marginLeft: 6,
            paddingBottom: 0,
            rowBreak: true
        });
    }

    private buildHourLabel(text: string, width: string): Label {
        return new Label({
            text,
            id: "labelHour-" + text,
            fontSize: "small",
            width,
            paddingLeft: 0,
            paddingRight: 0,
            marginLeft: 0,
            marginRight: 0
        });
    }
}
